import {
    Badge, Checkbox, Flex, Icon, Text,
} from '@chakra-ui/react';
import { ComponentProps } from 'react';
import { ServiceIcon } from '../service-icon';

function ServiceCheckbox({
    serviceName,
    serviceIcon,
    onChange = () => { },
    isChecked = false,
    hideCheckbox = false,
    labelText,
    labelColorScheme = 'danger',
    ...props
}: {
    serviceName: string;
    serviceIcon?: string;
    onChange?: (value: boolean) => void;
    isChecked?: boolean;
    hideCheckbox?: boolean;
    labelText?: string;
    labelColorScheme?: string;
} & Omit<ComponentProps<typeof Flex>, 'onChange'>) {
    return (
        <Flex
            as="label"
            htmlFor={`service-${serviceName}`}
            alignItems="center"
            borderColor="muted.50"
            borderWidth={1}
            py={2}
            px={2}
            gap={2}
            rounded="md"
            userSelect="none"
            cursor={hideCheckbox || labelText !== undefined ? undefined : 'pointer'}
            {...props}
        >
            <Icon color="primary.500" h={5} w={5}>
                <ServiceIcon service={serviceIcon !== undefined ? serviceIcon : serviceName} />
            </Icon>

            <Text
                as="label"
                htmlFor={`service-${serviceName}`}
                fontSize="sm"
                flexGrow={1}
                cursor={hideCheckbox || labelText !== undefined ? undefined : 'pointer'}
            >
                {serviceName}
            </Text>

            {
                labelText !== undefined && (
                    <Badge colorScheme={labelColorScheme} size="xs" variant="subtle">{labelText}</Badge>
                )
            }
            {
                labelText === undefined && !hideCheckbox && (
                    <Checkbox
                        id={`service-${serviceName}`}
                        isChecked={isChecked}
                        onChange={(e) => onChange(e.target.checked)}
                    />
                )
            }
        </Flex>
    );
}

export { ServiceCheckbox };
